import { takeLatest, call, put, select } from 'redux-saga/effects';
import { getSuccess, getFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../api/client';
function* getRequest() {
    try {
const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(apiGet, 'api/dashboard');
        yield put(getSuccess(response));
    } catch (error) {
        yield put(getFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('dashboard/getRequest', getRequest);
}

export default saga;
